import * as React from 'react';
import {RouterProvider} from 'react-router';
import {router} from './router';
import AppProviders from "./core/AppProviders";

export const Root = () => (
    <React.StrictMode>
        <AppProviders>
            <RouterProvider router={router}/>
        </AppProviders>
    </React.StrictMode>
);
